<template>
  <div class="">
      <div class="flex justify-between items-center my-2">
          <div class="w-1/5 pr-5 text-xs py-2">
              Search (Email, User Name, Full Name, Address, City, Country)
              <v-text-field placeholder="Name" variant="outlined" density="compact" v-model="searchName" rounded="0">
              </v-text-field>
          </div>
          <!-- total of every supplier balance (and of the rows matching the search, when filtering) -->
          <div class="flex items-center gap-6 px-4 py-2 border rounded text-sm" style="border-color: #345;">
              <div>
                  <div class="text-xs text-gray-400">Total supplier balances</div>
                  <div class="text-lg font-semibold">${{ money(totalBalance) }} <span class="text-xs text-gray-400">({{ Users.length }} suppliers)</span></div>
              </div>
              <div v-if="searchName.trim()">
                  <div class="text-xs text-gray-400">Matching search</div>
                  <div class="text-lg font-semibold">${{ money(filteredBalance) }} <span class="text-xs text-gray-400">({{ filteredUsers.length }})</span></div>
              </div>
          </div>
          <div>
              <v-btn icon="mdi-delete" size="small" style="outline: none;" @click="deleteCustomers"
                  class="mr-5 bg-dark text-light"></v-btn>
              <v-btn icon="mdi-plus" size="small" style="outline: none;" @click="addReseller" data-bs-toggle="modal"
                  data-bs-target="#customerAddModal" class="bg-dark text-light"></v-btn>
          </div>
      </div>
      <v-data-table :headers="headers" :items="filteredUsers" 
          item-key="name" class="reseller-table border h-[500px] bg-white text-black min-h-[500px]" 
          items-per-page="-1"
          style="font-size: 13px;" :style="`height: ${computedHeight}px;`">
          <template v-slot:[`item.no`]="{ index }">
              {{ index + 1 }}
          </template>
          <template v-slot:[`item.checkbox`]="{ item }">
              <div @click="toggleSelection(item)" class="ml-auto align-self-center"
                  style="width: 20px; height: 20px; cursor: pointer;">
                  <input :checked="isSelected(item)" class="form-check-input shadow-none" type="checkbox" />

              </div>
          </template>
          <template v-slot:[`item.add_balance`]="{ item }">
            <div class="ml-auto align-self-center flex gap-x-2 items-center justify-center">
                <v-text-field :id="item.email" variant="outlined" density="compact" type="number" width="100px" model-value="0"
                                  rounded="0"></v-text-field>
                <button @click="add_Balance(item)" class="w-[60px] bg-blue-400 rounded-lg hover:bg-blue-600 h-[30px]">Add</button>

            </div>
        </template>
          <template v-slot:[`item.payout`]="{ item }">
              <div class="payout-cell">
                  <div v-if="item.payout" class="flex items-center gap-1 payout-line">
                      <span v-if="item.payout.coin === 'Note'" class="coin-logo coin-logo--note" title="Note"><v-icon icon="mdi-note-text-outline" size="13"></v-icon></span>
                      <img v-else :src="coinLogo(item.payout.coin)" :alt="item.payout.coin" :title="item.payout.coin" class="coin-logo" />
                      <span v-if="item.payout.network" class="pchip">{{ item.payout.network }}</span>
                      <span :class="[item.payout.coin === 'Note' ? 'pnote-text' : 'paddr', isRecent(item.payout) ? 'is-recent' : '']"
                          :title="'Updated ' + shortDate(item.payout.updated_at) + (item.payout.updated_by ? ' by ' + item.payout.updated_by : '') + (item.payout.note ? ' · ' + item.payout.note : '')">{{ item.payout.address }}</span>
                      <button type="button" class="pbtn pbtn--pri" @click="copyAddress(item.payout.address)"><v-icon icon="mdi-content-copy" size="13"></v-icon>Copy</button>
                  </div>
                  <span v-else class="pmeta">Not set</span>
              </div>
          </template>
          <template v-slot:[`item.licenses`]="{ item }">
              <router-link
                  class="text-white"
                  :to="{ name: 'AdminLicensePage', query: { email: item.email }}"
              >
                  View
              </router-link>
          </template>
          <template v-slot:[`item.buttonBar`]="{ item }">
              <v-menu offset-y location="bottom">
                  <template v-slot:activator="{ props, on, isActive }">
                      <v-btn v-bind="props" v-on="{ ...on }" color="#234" density="compact"
                          :style="isActive ? 'border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;' : ''"
                          style="outline: none; font-size: 10px; " class="w-32 z-10 bg-dark text-light">
                          Actions
                          <v-icon icon="mdi-chevron-down" size="14"></v-icon>
                      </v-btn>
                  </template>
                  <v-list class="w-32 flex-1 flex flex-col px-0 py-0  z-0"
                      style="border-top-left-radius: 0px;border-top-right-radius: 0px">
                      <v-btn v-for="(button, index) in actionButtons" :key="index" @click="clickAction(item, button)"
                          rounded="0" class="text-center bg-dark text-light"
                          style="font-size: 10px; width: 128px; outline: none; border-bottom: 1px solid #345;"
                          :data-bs-toggle="(button === 'Update' || button === 'Adjust') && 'modal'"
                          :data-bs-target="button === 'Update' ? '#customerUpdateModal' : button === 'Adjust' ? '#refundModal': ''">
                          {{
                  button }}
                      </v-btn>
                  </v-list>
              </v-menu>
          </template>
      </v-data-table>
  </div>
  <div>
      <AddNewReseller @close="addNewOneDialogFlag = false" @updated="updatedHandler" />
      <UpdateInfoDialog @close="updateInfoDialogFlag = false" :item="selectedItem" @updated="updatedHandler" />
      <RefundDialog @close="refundDialogFlag = false" :item="selectedItem" @updated="updatedHandler" />
      <v-dialog v-model="payoutDialog" max-width="460">
          <div class="payout-dlg">
              <div class="payout-dlg__head"><span>Payout address · {{ payoutFor?.name || payoutFor?.email }}</span><button type="button" aria-label="Close" @click="payoutDialog = false">&times;</button></div>
              <div class="payout-dlg__body">
                  <div class="pcheck"><input type="checkbox" v-model="payoutForm.manual" class="form-check-input shadow-none" style="height: 18px; width: 18px;" /> Note (no crypto address)</div>
                  <div v-if="payoutForm.manual"><label>Note</label><v-textarea v-model="payoutForm.address" rows="3" auto-grow variant="outlined" density="compact" hide-details rounded="0"></v-textarea></div>
                  <template v-else>
                  <div class="grid grid-cols-2 gap-3">
                      <div><label>Coin</label><v-select v-model="payoutForm.coin" :items="COINS" variant="outlined" density="compact" hide-details rounded="0"></v-select></div>
                      <div><label>Network</label>
                          <v-select v-if="networksFor(payoutForm.coin).length" v-model="payoutForm.network" :items="networksFor(payoutForm.coin)" variant="outlined" density="compact" hide-details rounded="0"></v-select>
                          <v-text-field v-else v-model="payoutForm.network" variant="outlined" density="compact" hide-details rounded="0"></v-text-field>
                      </div>
                  </div>
                  <div v-if="payoutForm.coin === 'Other'"><label>Coin name</label><v-text-field v-model="payoutForm.otherCoin" variant="outlined" density="compact" hide-details rounded="0"></v-text-field></div>
                  <div><label>Address</label><v-text-field v-model="payoutForm.address" variant="outlined" density="compact" hide-details rounded="0" class="paddr-input"></v-text-field></div>
                  <div><label>Note</label><v-text-field v-model="payoutForm.note" variant="outlined" density="compact" hide-details rounded="0"></v-text-field></div>
                  </template>
              </div>
              <div class="payout-dlg__foot">
                  <button v-if="payoutHad" type="button" class="pbtn pbtn--danger mr-auto" :disabled="payoutBusy" @click="removePayout">Remove</button>
                  <button type="button" class="pbtn pbtn--lg" @click="payoutDialog = false">Cancel</button>
                  <button type="button" class="pbtn pbtn--lg pbtn--pri" :disabled="payoutBusy || !payoutForm.address.trim()" @click="savePayout">Save</button>
              </div>
          </div>
      </v-dialog>

  </div>
</template>
<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { useAdminUserStore, useAlertStore } from "@/stores"
import copy from "clipboard-copy"
// coin logos: cryptocurrency-icons 0.18.1 (CC0), only the ones used here
import logoUsdt from "@/assets/coins/usdt.svg"
import logoUsdc from "@/assets/coins/usdc.svg"
import logoBtc from "@/assets/coins/btc.svg"
import logoEth from "@/assets/coins/eth.svg"
import logoLtc from "@/assets/coins/ltc.svg"
import logoTrx from "@/assets/coins/trx.svg"
import logoSol from "@/assets/coins/sol.svg"
import logoGeneric from "@/assets/coins/generic.svg"
import { storeToRefs } from 'pinia';
import AddNewReseller from "./Modals/AddNewReseller.vue"
import UpdateInfoDialog from "./Modals/UpdateInfoDialog.vue"
import RefundDialog from "./Modals/RefundDialog.vue"

const headers = ref(
  [
      { title: 'No', align: 'center', key: 'no' },
      { title: '', align: 'center', key: 'checkbox' },
      { title: 'User Name', align: 'center', key: 'user_name' },
      { title: 'Full Name', align: 'center', key: 'name' },
      { title: 'Email', align: 'center', key: 'email' },
      { title: 'Add Balance', align: 'center', key: 'add_balance' },
      { title: 'Role', align: 'center', key: 'role' },
      { title: 'Balance', align: 'center', key: 'balance' },
      { title: 'Payout', align: 'left', key: 'payout', minWidth: '300px' },
      { title: 'Actions', align: 'center', key: 'buttonBar' },
  ]
);

// ---- payout address: one per reseller, shown in the table with a Copy button ----
const COINS = ['USDT', 'USDC', 'BTC', 'ETH', 'LTC', 'TRX', 'SOL', 'Other']
const COIN_LOGOS = { USDT: logoUsdt, USDC: logoUsdc, BTC: logoBtc, ETH: logoEth, LTC: logoLtc, TRX: logoTrx, SOL: logoSol }
const coinLogo = (coin) => COIN_LOGOS[String(coin || '').toUpperCase()] || logoGeneric
const NETWORKS = { USDT: ['TRC20', 'ERC20', 'BEP20', 'SOL', 'TON', 'Polygon'], USDC: ['ERC20', 'SOL', 'BEP20', 'Polygon', 'Base'], BTC: ['Bitcoin'], ETH: ['ERC20', 'Arbitrum', 'Base'], LTC: ['Litecoin'], TRX: ['TRC20'], SOL: ['Solana'] }
const networksFor = (coin) => NETWORKS[coin] || []
const payoutDialog = ref(false)
const payoutFor = ref(null)
const payoutHad = ref(false)
const payoutBusy = ref(false)
const payoutForm = ref({ manual: false, coin: 'USDT', network: 'TRC20', otherCoin: '', address: '', note: '' })   // manual: a typed note instead of a crypto address (saved as coin "Note")
watch(() => payoutForm.value.coin, (c) => { const n = networksFor(c); if (n.length && !n.includes(payoutForm.value.network)) payoutForm.value.network = n[0]; if (!n.length && Object.values(NETWORKS).flat().includes(payoutForm.value.network)) payoutForm.value.network = '' })
const copyAddress = (text) => { copy(text); useAlertStore().success('Copied') }
const isRecent = (p) => !!p && !!p.changed_at && Date.now() - new Date(p.changed_at).getTime() < 30 * 24 * 60 * 60 * 1000   // address added or changed in the last 30 days: shown red
const shortDate = (v) => v ? new Date(v).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''
const openPayout = (item, p) => {
  payoutFor.value = item
  payoutHad.value = !!p
  const known = p && COINS.includes(p.coin)
  payoutForm.value = p && p.coin === 'Note'
    ? { manual: true, coin: 'USDT', network: 'TRC20', otherCoin: '', address: p.address, note: '' }
    : p
    ? { manual: false, coin: known ? p.coin : 'Other', otherCoin: known ? '' : p.coin, network: p.network || '', address: p.address, note: p.note || '' }
    : { manual: false, coin: 'USDT', network: 'TRC20', otherCoin: '', address: '', note: '' }
  payoutDialog.value = true
}
const afterPayoutSave = (item, payout) => {
  item.payout = payout || null
  payoutDialog.value = false
}
const savePayout = async () => {
  const f = payoutForm.value
  const coin = f.manual ? 'Note' : f.coin === 'Other' ? f.otherCoin.trim() : f.coin
  if (!coin) { useAlertStore().error('Enter the coin name'); return }
  payoutBusy.value = true
  const res = await adminUserStore.saveResellerPayout(f.manual
    ? { user_id: payoutFor.value.user_id, coin, network: '', address: f.address.trim(), note: '' }
    : { user_id: payoutFor.value.user_id, coin, network: f.network.trim(), address: f.address.trim(), note: f.note.trim() })
  payoutBusy.value = false
  if (res) afterPayoutSave(payoutFor.value, res.payout)
}
const removePayout = async () => {
  if (!confirm('Remove the payout address for ' + (payoutFor.value.name || payoutFor.value.email) + '?')) return
  payoutBusy.value = true
  const res = await adminUserStore.saveResellerPayout({ user_id: payoutFor.value.user_id, address: '' })
  payoutBusy.value = false
  if (res) afterPayoutSave(payoutFor.value, null)
}

const addNewOneDialogFlag = ref(false)
const updateInfoDialogFlag = ref(false)
const refundDialogFlag = ref(false)
const searchName = ref("")
let addBal = ref(0);



const adminUserStore = useAdminUserStore()
const { Users } = storeToRefs(adminUserStore)
adminUserStore.loadResellerUsers()
const filteredUsers = computed(() => (Users.value || []).filter(u => [u.email, u.user_name, u.name, u.address, u.city, u.country].join(',').toLowerCase().includes(searchName.value.toLowerCase())))
const sumBalance = (list) => list.reduce((t, u) => t + (Number(u.balance) || 0), 0)
const totalBalance = computed(() => sumBalance(Users.value || []))
const filteredBalance = computed(() => sumBalance(filteredUsers.value))
const money = (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const selectedItems = ref([]);
const selectedItem = ref(null);

const offsetHeight = 300; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);

const add_Balance = async (item) => {
    if(Number(document.getElementById(item.email).value) === 0) return;
    await adminUserStore.updateUserBalance({uuid: item.uuid, balance: document.getElementById(item.email).value})
    document.getElementById(item.email).value = 0;
} 

const handleResize = () => {
computedHeight.value = window.innerHeight - offsetHeight;
};

onMounted(() => {
window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
window.removeEventListener('resize', handleResize);
});

const isSelected = (item) => {
  return selectedItems.value.includes(item); 
};

const toggleSelection = (item) => {
  const index = selectedItems.value.indexOf(item);
  if (index === -1) {
      selectedItems.value.push(item);
  } else {
      selectedItems.value.splice(index, 1);
  }
};




const addReseller = () => {
  addNewOneDialogFlag.value = true
}
const actionButtons = ref(
  ["Update", "Adjust", "Payout address"]
)
const clickAction = (item, button) => {
    selectedItem.value = item
    switch (button) {
        case "Update":
            updateInfoDialogFlag.value = true
            break
        case "Adjust":
            refundDialogFlag.value = true
            break
        case "Payout address":
            openPayout(item, item.payout)
            break
}
}

const updatedHandler = () => {
  addNewOneDialogFlag.value = false
  updateInfoDialogFlag.value = false
  refundDialogFlag.value = false
  adminUserStore.loadResellerUsers()
}

const deleteCustomers = () => {
  adminUserStore.deleteResellers(selectedItems.value.map(item => item.uuid)).then(() => {
      adminUserStore.loadResellerUsers()
  })

}
</script>

<style scoped>
.payout-cell { display: flex; flex-direction: column; gap: 2px; padding: 2px 0; }
.payout-line { flex-wrap: nowrap; white-space: nowrap; }
.reseller-table :deep(td), .reseller-table :deep(th) { padding: 0 8px !important; }
.payout-line .paddr { overflow-wrap: normal; font-size: 11.5px; }
.payout-line .pnote-text { white-space: nowrap; max-width: 320px; overflow: hidden; text-overflow: ellipsis; }
.coin-logo { width: 20px; height: 20px; border-radius: 50%; flex: none; }
.coin-logo--note { display: inline-flex; align-items: center; justify-content: center; background: var(--ui-card-2); border: 1px solid var(--ui-line); color: var(--ui-dim); }
.pchip { display: inline-block; padding: 1px 8px; border-radius: 999px; background: var(--ui-card-2); border: 1px solid var(--ui-line); font-size: 11.5px; font-weight: 600; }
.pbtn { display: inline-flex; align-items: center; gap: 4px; padding: 2px 8px; border: 1px solid var(--ui-line-strong); border-radius: 5px; font-size: 11.5px; color: inherit; background: transparent; cursor: pointer; }
.pbtn:disabled { opacity: 0.5; cursor: default; }
.pbtn--lg { padding: 6px 14px; font-size: 13px; }
.pbtn--pri { background: var(--ui-pri); border-color: var(--ui-pri); color: #ffffff; }
.pbtn--danger { border-color: var(--ui-dan); color: var(--ui-dan); }
.paddr { font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 12px; color: var(--ui-ok, #22c55e); overflow-wrap: anywhere; }
.paddr.is-recent, .pnote-text.is-recent { color: var(--ui-dan, #ef4444); }
.pmeta { color: var(--ui-dim); font-size: 11.5px; }
.pnote-text { white-space: pre-wrap; overflow-wrap: anywhere; font-size: 12.5px; }
.payout-dlg__body .pcheck { display: flex; align-items: center; gap: 8px; font-size: 13px; }
.payout-dlg { background: var(--ui-card); color: var(--ui-ink); border: 1px solid var(--ui-line); border-radius: 12px; }
.payout-dlg__head { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; border-bottom: 1px solid var(--ui-line); font-size: 16px; }
.payout-dlg__head button { font-size: 22px; line-height: 1; color: inherit; background: transparent; border: 0; cursor: pointer; }
.payout-dlg__body { display: flex; flex-direction: column; gap: 12px; padding: 14px 16px; }
.payout-dlg__body label { display: block; margin-bottom: 4px; color: var(--ui-dim); font-size: 12px; }
.payout-dlg__foot { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 16px; border-top: 1px solid var(--ui-line); }
.paddr-input :deep(input) { font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 12.5px; }
</style>
